import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://8830fd0daa3e1cf5c18e246945cd986f@o4510457297567744.ingest.us.sentry.io/4510457298944000",
  sendDefaultPii: false,
  tracesSampleRate: 0,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <ToastContainer position="top-center" autoClose={4000} hideProgressBar />
  </StrictMode>,
);
